export enum CoreResponseStatus {
    OK,
    Failed,
    Forbidden,
    NonAuthoritativeInformation,
    Error,
    NoData
}

export class CoreResponseMessage {    
    Status: CoreResponseStatus;
    Message: string;
    TotalDataCount: number;   
    Result: any;    
}